import axios from "axios";

export const createFormSubmitting = async (title, data) => {
  const response = await axios.post(`/api/forms-submittings`, {
    data: { title, data },
  });
  return response;
};
